export const PTU_PRECALCULATION_EVENTS = {
  DOWNLOADED_PTU_PRECALCULATION_FILE: 'DownloadedPTUPrecalculationFile',
  CALCULATE_AUTO_PTU_PRECALCULATION: 'CalculateAutoPTUPrecalculation',
  DOWNLOADED_PTU_PRECALCULATION_RESULTS: 'DownloadedPTUPrecalculationResults',
  SAVE_AUTO_PTU_PRECALCULATION_SUCCESS: 'SaveAutoPTUPrecalculationSuccess',
  SAVE_AUTO_PTU_PRECALCULATION_ERROR: 'SaveAutoPTUPrecalculationError',
  SAVE_MANUAL_PTU_PRECALCULATION_SUCCESS: 'SaveManualPTUPrecalculationSuccess',
  SAVE_MANUAL_PTU_PRECALCULATION_ERROR: 'SaveManualPTUPrecalculationError',
};
